var progressIndicator = function progressIndicator(tokens) {
  return {
    spinner: {
      indeterminate: {
        baseBorderColor: tokens.colors.neutral[100],
        progressBorderColor: tokens.colors.neutral[90],
        baseOpacity: tokens.opacity['sm'],
        strokeWidth: tokens.stroke.xs,
        borderRadius: tokens.radius.round,
        motion: tokens.motion.md,
        spacing: tokens.spacingX['xs']
      }
    }
  };
};

export default progressIndicator;